/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GroundWaterLevel } from "./GroundWaterLevel";
import {
  GroundWaterLevelFromJSON,
  GroundWaterLevelFromJSONTyped,
  GroundWaterLevelToJSON,
  GroundWaterLevelToJSONTyped,
} from "./GroundWaterLevel";

/**
 *
 * @export
 * @interface PaginatedGroundWaterLevelList
 */
export interface PaginatedGroundWaterLevelList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<GroundWaterLevel>;
}

/**
 * Check if a given object implements the PaginatedGroundWaterLevelList interface.
 */
export function instanceOfPaginatedGroundWaterLevelList(
  value: object
): value is PaginatedGroundWaterLevelList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedGroundWaterLevelListFromJSON(json: any): PaginatedGroundWaterLevelList {
  return PaginatedGroundWaterLevelListFromJSONTyped(json, false);
}

export function PaginatedGroundWaterLevelListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedGroundWaterLevelList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GroundWaterLevelFromJSON),
  };
}

export function PaginatedGroundWaterLevelListToJSON(json: any): PaginatedGroundWaterLevelList {
  return PaginatedGroundWaterLevelListToJSONTyped(json, false);
}

export function PaginatedGroundWaterLevelListToJSONTyped(
  value?: PaginatedGroundWaterLevelList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GroundWaterLevelToJSON),
  };
}
